import { API_URL } from "../constants.js";
import axios from 'axios';
import middleware from '../util/middleware';

var request = axios.create({
    baseURL: API_URL,
    headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
    }
})
export default class SegmentosPVRequest {

    /**
     * Función para cargar todos los segmentos
     */
    static CargarSegmentosTabla() {
        return middleware.hasAuth(() => request.get(`api/segmentos-punto-venta-configurados`));
    }

    /**
     * Función para crear un segmento
     * @param: values. valores para crear segmento
     */
    static NuevoSegmento(values) {
        return middleware.hasAuth(() => request.post(`api/segmentos-punto-venta`, values))
    }

    /**
     * Función para cargar lista de segmentos
     */
    static ListarSegmento() {
        return middleware.hasAuth(() => request.get(`api/segmentos-mic-disponibles`))
    }

    /**
     * Función para eliminar un segmento
     * @param: value. valores para eliminar segmento
     */
    static EliminarSegmento(value) {
        return middleware.hasAuth(() => request.put(`api/segmentos-punto-venta/eliminar/${value}`))
    }
}